import React from 'react'

import './error.css'
import Error from '../../assets/png/error404.gif';
import Errorimg from '../../assets/png/error.gif';

function error() {

	let url="simratsingh.netlify.app";
  return (
    <>
    
    <section class="page_404">
	{/* <div class="container">
		<div class="row">	
		<div class="col-sm-12 ">
		<div class="col-sm-10 col-sm-offset-1  text-center">
		<div class="four_zero_four_bg">
			<h1 class="text-center ">404</h1>
		
		
		</div>
		
		<div class="contant_box_404">
		<h3 class="h2">
		Look like you're lost
		</h3>
		
		<p>the page you are looking for not avaible!</p>
		
     <a href="" class="link_404">Go to Home</a>
	</div>
		</div>
		</div>
		</div>
	</div> */}

<div className='container'>

<img src={Error} id='errorimg'/>
<h3 id='errtxt1'>Looks Like You're Lost</h3>

<img src={Errorimg} id='errorimg2'/>

<p id='errtxt2'>The Page You Are Looking For Not Avaible!</p>

<a href={url} class="link_404">Go to Home</a>

<p id='errtxt3'>Still Facing Issues Mail Us < a id='mailid' href="mailto: simratsinghmehra01@gmail.com ">simratsinghmehra01@gmail</a></p>



</div>




</section>
    
    
    </>
  )
}

export default error